import { createFileRoute } from '@tanstack/react-router'

import { ControlGridPage } from '@/components/deliverables/control-grid-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { matching, readSearch } from '@/lib/search-params'

/** #367 : la grille de contrôle d'un livrable, sortie du livrable sur une page à elle. */
export const Route = createFileRoute('/_app/projects/$projectRef_/controles_/$key')({
  validateSearch: (search: Record<string, unknown>) =>
    readSearch(
      {
        ...RETURN_SHAPE,
        /** Lot 21 : l'entrée désignée depuis une tâche, mise en évidence. */
        controle: matching(/^[0-9a-f]{24}$/),
      },
      search,
    ),
  component: ControlGridRoutePage,
})

function ControlGridRoutePage() {
  const { projectRef, key } = Route.useParams()
  useFollowProjectClient(projectRef)
  const { controle } = Route.useSearch()
  return (
    <ControlGridPage key={key} projectRef={projectRef} deliverableKey={key} focusId={controle} />
  )
}
